<template lang="html">
    <div class="default-page-paddings">
        <div class="container container-small">
            <Heading :alignment="'text-left'" :title="$t('contact_title')" :routeName="'vignette'"></Heading>
            <div class="row">
                <div class="col-sm-5">
                    <div class="mt-4">
                        <p class="sub-header"><b>U.N.T.R.R. Bucuresti</b></p>

                        <p>
                            Str. Ienăchiţă Văcărescu Nr. 60<br/>
                            Bucureşti, Sector 4, 040157<br/>
                            Email: <a class="custom-link" href="mailto:office@e-rovinieta.ro">office@e-rovinieta.ro</a>
                        </p>

                        <p class="sub-header"><b>{{ $t('contact_viggnete_emission') }}</b></p>

                        <p>
                            Dna. Cerasela Lorent<br/>
                            Telefon: <a class="custom-link" href="tel:+40720999247">+40720999247</a><br/>
                            Email: <a class="custom-link" href="mailto:cerasela.lorent@untrr.ro">cerasela.lorent@untrr.ro</a>
                        </p>

                        <p>
                            Dna. Alamorean Marinela<br/>
                            Telefon: <a class="custom-link" href="tel:+40720999246">+40720999246</a><br/>
                            Email: <a class="custom-link" href="mailto:marinela.alamorean@untrr.ro">marinela.alamorean@untrr.ro</a>
                        </p>
                    </div>
                </div>
                <div class="col-sm-7">
                    <div class="contact-form">
                        <div class="form-group">
                            <label>{{$t('label_first_name')}}*</label>
                            <span class="invalid-feedback" v-if="errors.name.status">
                               {{errors.name.error}}
                            </span>
                            <input type="text" v-model="name" class="form-control">
                        </div>
                        <div class="form-group">
                            <label>{{$t('label_email')}}*</label>
                            <span class="invalid-feedback" v-if="errors.email.status">
                               {{errors.email.error}}
                            </span>
                            <input type="text" v-model="email" class="form-control">
                        </div>
                        <div class="form-group">
                            <label>{{$t('label_category')}}*</label>
                            <span class="invalid-feedback" v-if="errors.category.status">
                               {{errors.category.error}}
                            </span>
                            <select class="form-control" v-model="category">
                                <option :value="null">{{$t('label_choose_category_contact')}}</option>
                                <option v-for="i in 5" :value="i">{{$t('category_' + i)}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>{{$t('label_message')}}*</label>
                            <span class="invalid-feedback" v-if="errors.message.status">
                               {{errors.message.error}}
                            </span>
                            <textarea v-model="message" class="form-control" id="message"></textarea>
                        </div>
                        <div class="alert alert-success" v-if="contactSentStatus == 'success'">
                            {{$t('message_sent_successfully')}}
                        </div>
                        <div class="alert alert-danger" v-if="contactSentStatus == 'error'">
                            {{$t('message_sent_error')}}
                        </div>
                        <div class="form-group">
                            <van-button dusk="login-button" block v-if="!hideSendBtn" :loading="loading" @click="sendContactForm()" class="main-btn text-center" square>{{ $t('btn_send') }}</van-button>
                        </div>
                    </div>
                </div>
            </div>
            <p class="sub-header mt-4"><b>{{ $t('contact_agencies') }}</b></p>
            <p>
                <a class="custom-link" href="http://www.untrr.ro/birouri-regionale.html" target="_blank">{{ $t('contact_see_all_agencies') }}</a> {{ $t('contact_see_all_agencies_continuation') }}
            </p>
            <GmapMap
                :center="{lat: 44.421762, lng: 26.1013369}"
                :zoom="18"
                style="width: 100%; height: 300px"
            >
                <GmapMarker
                    :position="{lat: 44.421762, lng: 26.1013369}"
                />
                <GmapMarker
                    :position="{lat: 46.1988442, lng: 21.3311147}"
                />
                <GmapMarker
                    :position="{lat: 46.091314, lng: 21.688964}"
                />
                <GmapMarker
                    :position="{lat: 44.8604776, lng: 24.8813793}"
                />
                <GmapMarker
                    :position="{lat: 47.1031227, lng: 21.8308696}"
                />
                <GmapMarker
                    :position="{lat: 46.7772626, lng: 23.6140619}"
                />
                <GmapMarker
                    :position="{lat: 45.7968882, lng: 24.1459271}"
                />
                <GmapMarker
                    :position="{lat: 47.795759, lng: 22.870274}"
                />
                <GmapMarker
                    :position="{lat: 47.641079, lng: 26.252882}"
                />
                <GmapMarker
                    :position="{lat: 45.8697246, lng: 22.9151715}"
                />
                <GmapMarker
                    :position="{lat: 47.1749498, lng: 27.5305876}"
                />
                <GmapMarker
                    :position="{lat: 45.760854, lng: 21.2380413}"
                />
            </GmapMap>
        </div>
    </div>
</template>

<script>

import Heading from './snippets/Heading.vue'

export default {
    name: 'Contact',
    components: {
        Heading
    },
    props: {
    },
    data() {
        return {
            name: '',
            email: '',
            category: null,
            message: '',
            loading: false,
            errors: {
                name:  {
                    status: false,
                    error: ''
                },
                email:  {
                    status: false,
                    error: ''
                },
                category:  {
                    status: false,
                    error: ''
                },
                message:  {
                    status: false,
                    error: ''
                }
            },
            hideSendBtn: false,
            contactSentStatus: ''
        }
    },
    methods: {
        async sendContactForm() {
            if(!this.validate()) {
                return false;
            }

            this.loading = true;
            let payload = {
                name: this.name,
                email: this.email,
                category: this.category,
                message: this.message
            }

            try {
                let response = await this.$axios.post('/contact', payload);
                this.loading = false;
                if(response.data.status) {
                    this.hideSendBtn = true;
                    this.contactSentStatus = 'success';
                }
                else {
                    this.contactSentStatus = 'error';
                }
            }
            catch(error) {
                this.loading = false;

                if(error.response) {
                    this.$dialog.alert({
                        'message': error.response.data.error.error_msg,
                        'confirmButtonText': this.$t('btn_i_understand')
                    });
                }
            }
        },

        validate() {
            let ok = true;

            Object.keys(this.errors).map(item => {
                this.errors[item].status = false;
                this.errors[item].error = '';
            })

            if(!this.name.trim()) {
                this.errors.name.status = true;
                this.errors.name.error = this.$t('mandatory');
                ok = false;
            }

            if(!this.email.trim()) {
                this.errors.email.status = true;
                this.errors.email.error = this.$t('mandatory');
                ok = false;
            }

            if(!this.isEmailValid(this.email.trim())) {
                this.errors.email.status = true;
                this.errors.email.error = this.$t('invalid');
                ok = false;
            }

            if(!this.category) {
                this.errors.category.status = true;
                this.errors.category.error = this.$t('mandatory');
                ok = false;
            }

            if(!this.message) {
                this.errors.message.status = true;
                this.errors.message.error = this.$t('mandatory');
                ok = false;
            }

            return ok;
        }
    }
}

</script>

<style lang="scss" scoped>
    p {
    }

    .sub-header {
        font-size: 18px;

        &:not(:first-child) {
            margin-top: 50px;
        }
    }

    #message {
        height: 150px;
    }

    .contact-form {
        @media only screen and (min-width: 768px) {
            margin-left: 50px;
        }
    }
</style>
